export const formatBillingDate = (timestampSeconds: number) =>
  new Date(timestampSeconds * 1000).toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

export const formatBytes = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const FENCE = "`".repeat(16)
const fenceCode = (code: string) => {
  return [
    [FENCE, "python"].join(""),
    code,
    FENCE,
  ].join("\n");
};

export const splitByTags = (code: string) => {
  const pythonTagsRegex = new RegExp(`
    <python>
    ([\\s\\S]*?)
    </python>
    `.trim().replace(/[\t ]/g, ""), "g");
  const matches = [...code.matchAll(pythonTagsRegex)].map(m => m[1].trim());
  if (matches.length > 0) {
    return matches;
  }
  return [code];
};

export const codeMd = (code: string) => {
  const parts = splitByTags(code);
  const r =parts.map(part => fenceCode(part)).join("\n---\n");
  return r
};
